// extracted by css-extract-rspack-plugin
export default {"dimensionPicker":"zcYI9"};